import React, {memo} from 'react';
import Dialog from 'components/Dialog';
import {Grid} from '@mui/material';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import * as yup from 'common/yup';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {AutocompleteProps, FormAutocomplete} from 'components/inputs/FormAutocomplete';

const validationSchema = yup.object({
   name: yup.string().required(),
});
export type NameFormType = yup.InferType<typeof validationSchema>;

export interface ReplaceKeyDialogProps {
   data: {
      title: string;
      label: string;
      open?: boolean;
      value?: string;
      options: AutocompleteProps['options'];
   };
   onClose: (nameObj?: NameFormType, callbacks?: FormOnSubmitHelpers<NameFormType>) => void;
}
export const ReplaceKeyDialog = memo(
   ({
      data: {title, value, label, open = true, options},
      onClose: onSubmit,
   }: ReplaceKeyDialogProps) => {
      const onClose = React.useCallback(() => onSubmit(), [onSubmit]);
      return (
         <Dialog open={open} maxWidth="sm" header={title} close={onClose}>
            <Formik
               initialValues={validationSchema.cast({name: value})}
               initialTouched={Boolean(value) ? ['name'] : undefined}
               validationSchema={validationSchema}
               onSubmit={onSubmit}
            >
               <ReplaceKeyForm cancel={onClose} label={label} options={options} />
            </Formik>
         </Dialog>
      );
   }
);

const ReplaceKeyForm = ({
   label,
   cancel,
   options,
}: {
   label: string;
   cancel: () => void;
   options: AutocompleteProps['options'];
}) => {
   return (
      <>
         <Grid container spacing={3} justifyContent="center">
            <Grid item sm={11}>
               <FormAutocomplete name="name" label={label} options={options} />
            </Grid>
         </Grid>
         <Grid container spacing={3} justifyContent="center">
            <Grid item>
               <FormFooterButtons cancel={cancel} />
            </Grid>
         </Grid>
      </>
   );
};
